<template>
    <div>
        <span v-for="(list, index) in data.groups" :key="list.tra_id" @click.stop>
            <Link :href="route('groups.view', list.tra_id)" class="text-blue-600 hover:underline" >
              {{ list.title }}</Link><span v-if="index < data.groups.length - 1">, </span>
        </span>
    </div>

</template>


<script>

export default {
    name: 'ContactTableList',
    props: ['data'],
    data: () => ({
        showTooltip: false,
    }),
    computed: {
    },
}


</script>
